var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrepaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:electricity"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7532 4.16699V27.0837H21.0032V45.8337L35.5865 20.8337H27.2532L35.5865 4.16699H14.7532Z",
    fill: "#152344"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepaid);
export default __webpack_public_path__ + "static/media/prepaid.8e1336786270552592a9c7eadf9c1115.svg";
export { ForwardRef as ReactComponent };